import React, { useState } from 'react'
import AdminTitle from '../../../common/AdminTitle/AdminTitle'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TextInputComponent,ManualPaymentOptionsCompoent } from '../../../common/Form/Input.component'
import { useListAllQuery } from '../../../api/product.api'
import LoadingComponent from '../../../common/Loading/Loading.component'
import * as Yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useFieldArray } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import Select from "react-select"
import { useManualCreateOrderMutation } from '../../../api/order.api';
import { useNavigate } from 'react-router-dom';
import { SubmitButton } from '../../../common/Form/Input.component';

const OrderManualForm = () => {
    const [loading, setLoading] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState({}) // Track selected products by index
    const {data, error, isLoading} = useListAllQuery({ page: 1, limit: 20 });
    const productList = data?.result
    const [createManualOrder, {isLoading:isCreating}] = useManualCreateOrderMutation();
    const navigate = useNavigate();
    

    const itemsDTO = Yup.object({
        productId: Yup.mixed().required('Product is required'),
        size: Yup.mixed().required('Size is required'),
        quantity: Yup.number().integer().min(0).required('Quantity is required')
    })

    const orderDTO = Yup.object({
        items: Yup.array().of(itemsDTO).required('Items are required'),
        customerName: Yup.string().required('Customer name is required'),
        address: Yup.string().required('Address is required'),
        number: Yup.string().required('Number is required'),
        optionalNumber: Yup.string().notRequired().nullable().optional(),
        height: Yup.string().notRequired().nullable().optional(),
        weight: Yup.string().notRequired().nullable().optional(),
        discount: Yup.number().min(0).max(100).notRequired().nullable().transform((value, originalValue) => {
            return originalValue === '' || originalValue === null ? null : Number(originalValue);
        }),
        total: Yup.number().min(0).required('Total is required').transform((value, originalValue) => {
            return originalValue === '' ? undefined : Number(originalValue);
        }),
        advancePayment: Yup.number().min(0).notRequired().nullable().transform((value, originalValue) => {
            return originalValue === '' || originalValue === null ? 0 : Number(originalValue);
        }),
        paymentType: Yup.mixed().required('Payment type is required'),
    })

    const {control, handleSubmit, register, watch, formState:{errors}, setError } = useForm({
        resolver: yupResolver(orderDTO),
        defaultValues: {
            items: [{ productId: '', size: '', quantity: 1 }], // Initialize with one product item
            height: '',
            weight: '',
            total: '',
            discount: '',
            advancePayment: '',
        }
    })
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'items'
    });

    // Watch form values for real-time calculation
    const watchTotal = Number(watch('total', 0)) || 0;
    const watchDiscount = Number(watch('discount', 0)) || 0;
    const watchAdvance = Number(watch('advancePayment', 0)) || 0;
    
    // Calculate net total and remaining balance from watched values
    const discountAmount = (watchDiscount / 100) * watchTotal;
    const netTotal = Math.max(0, watchTotal - discountAmount);
    const advanceAmount = Math.max(0, watchAdvance);
    const remainingBalance = Math.max(0, netTotal - advanceAmount);

    const submitEvent = async(data) => {
        setLoading(true);
        try{
            const submitData = {
                ...data,
                total: Number(netTotal),
                advancePayment: Number(advanceAmount),
                remainingAmount: Number(remainingBalance),
                discount: data.discount ? Number(data.discount) : null,
                paymentType: data.paymentType?.value || data.paymentType,
                optionalNumber: data.optionalNumber || "",
                height: data.height || null,
                weight: data.weight || null,
                items: data.items.map(item => ({
                    productId: item.productId?.value || item.productId,
                    size: item.size?.value || item.size,
                    quantity: parseInt(item.quantity)
                }))
            }
            await createManualOrder(submitData).unwrap();
            toast.success("Order created successfully");
            navigate('/dashboard/order_list');
        }catch(exception){
            
            // Handle backend error responses
            let hasFieldErrors = false;
            
            // Check for field-level validation errors (from Joi validator)
            if (exception?.data?.result && typeof exception.data.result === 'object') {
                const validationErrors = exception.data.result;
                
                // Set errors on form fields so they appear below inputs
                Object.entries(validationErrors).forEach(([field, message]) => {
                    setError(field, {
                        type: 'server',
                        message: message
                    });
                });
                
                hasFieldErrors = true;
                toast.error("Please fix the validation errors");
            } 
            // Check for general error message (not field-specific)
            else if (exception?.data?.message) {
                toast.error(exception.data.message);
            }
            // Fallback to other possible error formats
            else if (exception?.message) {
                toast.error(exception.message);
            }
            else {
                toast.error("Error while creating manual order");
            }
        }finally{
            setLoading(false);
        }
        
    }
  return (
    <div className='admin_margin_box'>
        {isLoading && <LoadingComponent/>}
        <ToastContainer />
        <div className="admin_titles">
            <AdminTitle label1=" Order List" label2="/Add Order" url="/dashboard/order_list" />
            <div className='Dashboard_title'>
                <h1>Add Manual Order</h1>
            </div>
        </div>
        <div className="banner_form">
        <form onSubmit={handleSubmit(submitEvent)}>
            {/* Product Section */}
            <div className="product_section">
                <h3 style={{marginTop:'30px'}}>Products</h3>
                <div className="products_container">
                    {fields.map((item, index) => (
                        <div key={item.id} className="product_item" style={{ 
                            marginBottom: '20px', 
                            padding: '15px', 
                            border: '1px solid #ddd', 
                            borderRadius: '8px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                <h4>Product {index + 1}</h4>
                                {fields.length > 1 && (
                                    <button 
                                        type="button" 
                                        onClick={() => remove(index)} 
                                        style={{
                                            background:'#d74747', 
                                            color: 'white',
                                            padding:'5px 10px', 
                                            borderRadius:'5px',
                                            border: 'none',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Remove Product
                                    </button>
                                )}
                            </div>
                            
                            <div className="product_form_grid" style={{ display: 'grid', gap: '15px' }}>
                                <div>
                                    <label htmlFor="productId">Select Product</label>
                                    <Controller
                                        name={`items.${index}.productId`}
                                        control={control}
                                        render={({ field }) => (
                                        <Select
                                            options={productList? productList.map((product) => ({
                                            value: product._id,
                                            label: product.title,
                                            })) 
                                            : []
                                        }
                                            onChange={(selectedOption) => {
                                                field.onChange(selectedOption);
                                                // Store the full product data for this index
                                                if (selectedOption) {
                                                    const fullProduct = productList.find(p => p._id === selectedOption.value);
                                                    setSelectedProducts(prev => ({
                                                        ...prev,
                                                        [index]: fullProduct
                                                    }));
                                                }
                                            }}
                                            value={field.value}
                                            placeholder="Select product"
                                        />
                                        )}
                                    />
                                    {errors?.items?.[index]?.productId && (
                                        <span style={{ color: "red", fontStyle: "italic" }}>
                                        {errors.items[index].productId.message}
                                        </span>
                                    )}
                                </div>

                                <div>
                                    <label htmlFor="size">Select Size</label>
                                    <Controller
                                        name={`items.${index}.size`}
                                        control={control}
                                        render={({ field }) => {
                                            const currentProduct = selectedProducts[index];
                                            const availableSizes = currentProduct?.sizes || [];                                
                                            return (
                                                <Select
                                                    options={availableSizes.map((sizeObj) => ({
                                                        value: sizeObj.size,
                                                        label: `${sizeObj.size} (Stock: ${sizeObj.quantity})`,
                                                    }))}
                                                    onChange={(selectedOption) => {
                                                        field.onChange(selectedOption);
                                                    }}
                                                    value={field.value}
                                                    placeholder="Select Size"
                                                    isDisabled={!currentProduct}
                                                />
                                            )
                                        }}
                                    />
                                    {errors?.items?.[index]?.size && (
                                        <span style={{ color: "red", fontStyle: "italic" }}>
                                        {errors.items[index].size.message}
                                        </span>
                                    )}
                                </div>

                                <div>
                                    <label>
                                        Quantity:
                                        <input
                                            {...register(`items.${index}.quantity`)}
                                            placeholder="Quantity"
                                            type="number"
                                            min="1"
                                            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                                        />
                                        {errors.items?.[index]?.quantity && <p style={{ color: 'red' }}>{errors.items[index].quantity.message}</p>}
                                    </label>
                                </div>
                            </div>
                        </div>
                    ))}

                    <button 
                        type="button" 
                        onClick={() => append({ productId: '', size: '', quantity: 1 })} 
                        style={{
                            background:'#28a745', 
                            color: 'white',
                            padding:'10px 15px', 
                            borderRadius:'5px',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        + Add Another Product
                    </button>
                </div>
            </div>
            <div>
                <label htmlFor="customerName">Customer Name</label><br />
                <TextInputComponent
                    name='customerName'
                    control={control}
                    type='text'
                    defaultValue=''
                    errMsg={errors?.customerName?.message}
                    required:true
                />
            </div>
            <div>
                <label htmlFor="address">Address</label><br />
                <TextInputComponent
                    name='address'
                    control={control}
                    type='text'
                    defaultValue=''
                    errMsg={errors?.address?.message}
                    required:true
                />
            </div>
            <div>
                <label htmlFor="number">Number</label><br />
                <TextInputComponent
                    name='number'
                    control={control}
                    type='text'
                    defaultValue=''
                    errMsg={errors?.number?.message}
                    required:true
                />
            </div>
            <div>
                <label htmlFor="optionalNumber">Optional Number</label><br />
                <TextInputComponent
                    name='optionalNumber'
                    control={control}
                    type='text'
                    defaultValue=''
                    errMsg={errors?.optionalNumber?.message}
                />
            </div>
            <div>
                <label htmlFor="height">Height (Optional)</label><br />
                <TextInputComponent
                    name='height'
                    control={control}
                    type='text'
                    defaultValue=''
                    placeholder="e.g. 5'7&quot; or 170cm"
                    errMsg={errors?.height?.message}
                />
            </div>
            <div>
                <label htmlFor="weight">Weight (Optional)</label><br />
                <TextInputComponent
                    name='weight'
                    control={control}
                    type='text'
                    defaultValue=''
                    placeholder="e.g. 65kg"
                    errMsg={errors?.weight?.message}
                />
            </div>
            <div>
                <label htmlFor="total">Total Amount</label><br />
                <TextInputComponent
                    name='total'
                    control={control}
                    type='number'
                    min='0'
                    step='0.01'
                    errMsg={errors?.total?.message}
                />
            </div>
            <div>
                <label htmlFor="discount">Discount (in %)</label><br />
                <TextInputComponent
                    name='discount'
                    control={control}
                    type='number'
                    min='0'
                    max='100'
                    step='0.01'
                    errMsg={errors?.discount?.message}
                />
                {watchDiscount > 0 && (
                    <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                        Discount Amount: Rs. {discountAmount.toFixed(2)}
                    </p>
                )}
            </div>
            <div>
                <label htmlFor="advancePayment">Advance Payment (in Rs.)</label><br />
                <TextInputComponent
                    name='advancePayment'
                    control={control}
                    type='number'
                    min='0'
                    step='0.01'
                    placeholder="0.00"
                    errMsg={errors?.advancePayment?.message}
                />
                {advanceAmount > 0 && (
                    <p style={{ fontSize: '12px', color: '#059669', marginTop: '5px', fontWeight: 600 }}>
                        Advance Paid: Rs. {advanceAmount.toFixed(2)} | Remaining Balance: Rs. {remainingBalance.toFixed(2)}
                    </p>
                )}
            </div>
            {watchTotal > 0 && (
                <div style={{ 
                    padding: '16px', 
                    backgroundColor: '#f8fafc', 
                    borderRadius: '8px', 
                    marginTop: '15px', 
                    border: '1.5px solid #cbd5e1' 
                }}>
                    <h3 style={{ margin: '0 0 12px 0', color: '#1e293b', fontSize: '16px', fontWeight: 700 }}>
                        📊 Financial Breakdown
                    </h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '6px 0', fontSize: '14px', color: '#475569' }}>
                        <span>Subtotal:</span>
                        <span>Rs. {watchTotal.toFixed(2)}</span>
                    </div>
                    {watchDiscount > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '6px 0', fontSize: '14px', color: '#e11d48' }}>
                            <span>Discount ({watchDiscount}%):</span>
                            <span>-Rs. {discountAmount.toFixed(2)}</span>
                        </div>
                    )}
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        margin: '8px 0', 
                        paddingTop: '8px', 
                        borderTop: '1px solid #e2e8f0', 
                        fontSize: '15px', 
                        fontWeight: 700, 
                        color: '#0f172a' 
                    }}>
                        <span>Net Total:</span>
                        <span>Rs. {netTotal.toFixed(2)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '6px 0', fontSize: '14px', fontWeight: 600, color: '#059669' }}>
                        <span>Advance Payment:</span>
                        <span>Rs. {advanceAmount.toFixed(2)}</span>
                    </div>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        margin: '10px 0 0 0', 
                        paddingTop: '10px', 
                        borderTop: '2px dashed #cbd5e1', 
                        fontSize: '16px', 
                        fontWeight: 800,
                        color: remainingBalance <= 0 ? '#059669' : '#dc2626'
                    }}>
                        <span>Remaining Balance:</span>
                        <span>{remainingBalance <= 0 ? 'Rs. 0.00 (Fully Paid)' : `Rs. ${remainingBalance.toFixed(2)}`}</span>
                    </div>
                </div>
            )}
            <div>
                <label htmlFor="paymentType">Payment Type</label><br />
                <ManualPaymentOptionsCompoent
                name='paymentType'
                control={control}
                errMsg={errors?.paymentType?.message}
                required
                style={{height:'55px !important'}}
                />
            </div>
            <SubmitButton loading={loading} value="Create Order" disabled={isLoading}/>
            
        </form>

        </div>
    </div>
  )
}

export default OrderManualForm